module.exports = __webpack_public_path__ + "assets/img/0418.558357ce.png";